// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3z6WR","label":"Completed_label__6tSl0"};